import { toString } from '../lib/html.js';

/**
 * Base das telas. Cada tela é um custom element usado pelo ion-router (ion-router-outlet).
 *
 * Subclasses implementam:
 *   template() → html`...` (renderizado uma vez)
 *   setup()    → liga eventos (uma vez)
 *   onEnter()  → toda vez que a tela aparece (opcional)
 */
export class Page extends HTMLElement {
  connectedCallback() {
    if (!this._ready) {
      this._ready = true;
      this.innerHTML = toString(this.template());
      this.setup?.();
      this.addEventListener('ionViewWillEnter', () => this.onEnter?.());
    }
  }

  /** @param {string} selector */
  $(selector) {
    return this.querySelector(selector);
  }
}

/** Navega. direction: 'forward' | 'back' | 'root' */
export function go(path, direction = 'forward') {
  return document.querySelector('ion-router').push(path, direction);
}

/** Cabeçalho da marca usado nas telas de acesso. */
export const brand = (subtitle) => `
  <div class="brand">
    <img class="brand-logo logo-light" src="/brand/ticketcar-blue.svg" alt="TicketCar" /><img class="brand-logo logo-dark" src="/brand/ticketcar-white.svg" alt="TicketCar" />
    ${subtitle ? `<p class="brand-subtitle">${subtitle}</p>` : ''}
  </div>`;
